export default __webpack_public_path__ + "static/media/arm_swing_Walk.8459e042.jpg";